<div class="modal-content">

    <div class="modal-body">

     <div class="row">
        <div class="col-lg-4 col-12 border-right assinatura">
          <h3>{{contrato?.empresa?.nome}}</h3>
          <h4>Ative seu plano pagando a 1° Fatura</h4>

         <div *ngIf="contrato.id">
           <div class="mt-2 nome-plano">
             <label>Plano:</label>  <span class="font-16 ml-2 text-success">
            <b> {{contrato.plano?.nome}}</b></span> | {{contrato.limiteContatos | number}} contatos ativos.

           </div>

          <!-- <div class="alert alert-info mt-2" *ngIf="ehCobrancaGrupo()">
             Este contrato faz parte de um grupo de faturamento. O pagamento abaixo corresponde à fatura consolidada do grupo.
           </div> -->

         </div>

         <div *ngIf="contrato.proximaFatura">
          <app-fatura-detalhes [fatura]="contrato.proximaFatura"></app-fatura-detalhes>
         </div>

          <div *ngIf="!contrato.id">
            <div class="alert alert-info mt-2" role="alert">
              <i class="mdi mdi-check-all mr-2"></i> Aguardando contrato ser registrado no sistema.
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

          </div>

          <div *ngIf="!contrato.proximaFatura">
            <div class="alert alert-info mt-2" role="alert">
              <i class="mdi mdi-check-all mr-2"></i> Aguardando criação da fatura
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

          </div>


          <div class="alert alert-danger alert-dismissible fade show mt-2" role="alert" *ngIf="erro">
            <i class="mdi mdi-check-all mr-2"></i> {{erro}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>


          <div class="aceite-documentos" *ngIf="aceiteDocumentosPendente">
            <div class="aceite-documentos-opcao">
              <input id="aceite-documentos" type="checkbox" [(ngModel)]="aceitouDocumentos">
              <label for="aceite-documentos">
                Li e aceito o <a href="/contrato-adesao-uso" target="_blank" rel="noopener">Contrato de Adesão</a>
                e os <a href="/termos-de-uso" target="_blank" rel="noopener">Termos de Uso</a>.
              </label>
            </div>
            <button type="button" class="btn btn-success"
                    [disabled]="!aceitouDocumentos || aceitandoDocumentos"
                    (click)="continueParaPagamento()">
              {{aceitandoDocumentos ? 'Confirmando aceite...' : 'Continuar para pagamento'}}
            </button>
          </div>

          <div class="meios-pagamento" *ngIf="!aceiteDocumentosPendente">

          <div class="alert alert-info mt-2" *ngIf="contrato.proximaFatura && !faturaPodeSerPaga && !pago">
            Esta fatura não está disponível para pagamento. Status: {{contrato.proximaFatura.status}}.
          </div>

          <div class="abas-pagamento" *ngIf="!pago && formasPagamentoDisponiveis.length">
            <button type="button" *ngFor="let forma of formasPagamentoDisponiveis"
                    [class.ativa]="formaPagamentoAtiva === forma"
                    (click)="selecioneFormaPagamento(forma)">
              <i class="fa"
                 [ngClass]="{
                   'fa-qrcode': forma === 'pix',
                   'fa-credit-card': forma === 'cartao',
                   'fa-barcode': forma === 'boleto'
                 }"></i>
              <span *ngIf="forma === 'pix'">Pix</span>
              <span *ngIf="forma === 'cartao'">Cartão</span>
              <span *ngIf="forma === 'boleto'">Boleto</span>
            </button>
          </div>

          <div [hidden]="pago || formaPagamentoAtiva !== 'cartao'"
               *ngIf="contrato.proximaFatura && contrato.pagaNoCartao">
              <section class="autenticacao-3ds" *ngIf="urlAutenticacao3DSSegura">
                <h4>Autentique o cartão</h4>
                <p>Conclua a validação solicitada pelo banco emissor. O pagamento será confirmado depois da autorização.</p>
                <iframe [src]="urlAutenticacao3DSSegura" title="Autenticação 3D Secure"></iframe>
                <a [href]="urlAutenticacao3DS" target="_blank" rel="noopener">Abrir autenticação em outra janela</a>
              </section>
              <div class="alert alert-info" *ngIf="pagamentoCartaoPendente && !urlAutenticacao3DSSegura">
                Pagamento enviado. Aguardando a confirmação do banco.
              </div>
              <cad-cartaocredito #cccompoment (onCriou)="ativeViaCartao($event)"
                                 [parcelamento]="{numeroParcelas: (contrato.proximaFatura?.parcelamentoMaximo || contrato.numeroParcelas), total: contrato.proximaFatura.total}"
                                 [provedorPagamento]="contrato.proximaFatura?.provedorPagamento"
                                 *ngIf="!pagamentoCartaoPendente">

              </cad-cartaocredito>
          </div>

          <app-pagamento-pix-fatura *ngIf="contrato.proximaFatura?.pix"
               [hidden]="pago || formaPagamentoAtiva !== 'pix'"
               [pix]="contrato.proximaFatura.pix"></app-pagamento-pix-fatura>

          <span [hidden]="!pago">
             <h4 class="text-success text-center">Seu plano foi ativado com sucesso!</h4>
          </span>

          <div *ngIf="contrato.proximaFatura?.boleto"
               [hidden]="pago || formaPagamentoAtiva !== 'boleto'" class="conteudo-pagamento">
            <img class="boleto" [src]="contrato.proximaFatura.boleto.urlCodigoBarras" >

            <span class="font-12 text-center d-block">
              {{contrato.proximaFatura.boleto.codigoBarras}}
            </span>

            <a class="btn btn-info mt-2" target="_blank" href="{{contrato.proximaFatura.linkPagamento}}"   >
              Imprimir boleto
            </a>

          </div>
          </div>

        </div>

        <div class="col-lg-8 col-0 quadro">
          <div class="bg-cartao" *ngIf="formaPagamentoAtiva === 'cartao'">
            <div class="promo-info ">
              <h3>Ative seu plano com seu cartão de crédito e garanta seu desconto.</h3>
              <p>E começe a melhorar o ciclo de retorno diminuindo o tempo de recorrência
              dos seus clientes.</p>
            </div>

          </div>

          <div class="bg-ativacao" *ngIf="formaPagamentoAtiva === 'boleto' ">
            <div class="promo-info ">
              <h3>Ative seu plano pagando o boleto e começe a faturar mais.</h3>
              <p>E começe a melhorar o ciclo de retorno diminuindo o tempo de recorrência
                dos seus clientes.</p>
            </div>
          </div>

          <div class="bg-ativacao" *ngIf="formaPagamentoAtiva === 'pix'">
            <div class="promo-info ">
              <h3>Ative seu plano fazendo transferência via Pix e começe a faturar mais.</h3>
              <p>E começe a melhorar o ciclo de retorno diminuindo o tempo de recorrência
                dos seus clientes.</p>
            </div>
          </div>

        </div>
     </div>


    </div>

</div>
